import React from "react";
import { Mail, Phone, MapPin, MessageCircle, ArrowUpRight, Linkedin, Github } from "lucide-react";
import { PROFILE } from "../../data/profile";

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative py-28 sm:py-40 border-t border-white/[0.06] overflow-hidden"
    >
      <div className="pointer-events-none absolute -top-32 left-1/2 -translate-x-1/2 h-[420px] w-[820px] rounded-full bg-[var(--jewel)] opacity-[0.07] blur-3xl" />
      <div className="relative mx-auto max-w-7xl px-5">
        <span className="text-eyebrow">// 06 · Contact</span>
        <h2
          className="text-display mt-4"
          style={{ fontSize: "clamp(3rem, 9vw, 8rem)", lineHeight: 0.92 }}
        >
          Let's build <em className="italic text-[var(--jewel)]">something</em>.
        </h2>
        <p className="mt-6 max-w-2xl text-lg sm:text-xl text-muted-foreground font-serif italic">
          Open to full-time roles, freelance projects, and collaborations.
        </p>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-12 gap-4">
          {/* LinkedIn + GitHub stacked — spans 7 cols */}
          <div className="md:col-span-7 grid grid-cols-1 gap-4">
            <a
              href={PROFILE.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-linkedin"
              className="group rounded-2xl border border-white/10 bg-white/[0.025] p-7 hover:border-[var(--jewel)] transition-colors"
            >
              <div className="flex items-center justify-between">
                <span className="text-eyebrow flex items-center gap-2">
                  <Linkedin size={12} /> LinkedIn
                </span>
                <ArrowUpRight
                  className="text-muted-foreground group-hover:text-[var(--jewel)] group-hover:-translate-y-1 group-hover:translate-x-1 transition-all"
                  size={20}
                />
              </div>
              <p className="mt-4 font-serif text-2xl sm:text-3xl truncate">
                /in/shivmuratg
              </p>
            </a>

            <a
              href={PROFILE.github}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-github"
              className="group rounded-2xl border border-white/10 bg-white/[0.025] p-7 hover:border-[var(--jewel)] transition-colors"
            >
              <div className="flex items-center justify-between">
                <span className="text-eyebrow flex items-center gap-2">
                  <Github size={12} /> GitHub
                </span>
                <ArrowUpRight
                  className="text-muted-foreground group-hover:text-[var(--jewel)] group-hover:-translate-y-1 group-hover:translate-x-1 transition-all"
                  size={20}
                />
              </div>
              <p className="mt-4 font-serif text-2xl sm:text-3xl truncate">
                /galaxeeranger
              </p>
            </a>
          </div>
          
          {/* Phone + WhatsApp— spans 5 cols */}
          <div className="md:col-span-5 grid grid-cols-1 gap-4">
            <a
              href={`tel:${PROFILE.phone.replace(/\s/g, "")}`}
              data-testid="contact-phone"
              className="group rounded-2xl border border-white/10 bg-white/[0.025] p-6 hover:border-[var(--jewel)] transition-colors"
            >
              <div className="flex items-center justify-between">
                <span className="text-eyebrow flex items-center gap-2">
                  <Phone size={12} /> Phone
                </span>
                <ArrowUpRight
                  className="text-muted-foreground group-hover:text-[var(--jewel)] transition-colors"
                  size={18}
                />
              </div>
              <p className="mt-3 font-serif text-xl truncate">{PROFILE.phone}</p>
            </a>
          
            <a
              href={PROFILE.whatsapp}
              target="_blank"
              rel="noreferrer"
              data-testid="contact-whatsapp"
              className="group rounded-2xl border border-white/10 bg-white/[0.025] p-6 hover:border-[var(--jewel)] transition-colors"
            >
              <div className="flex items-center justify-between">
                <span className="text-eyebrow flex items-center gap-2">
                  <MessageCircle size={12} /> WhatsApp
                </span>
                <ArrowUpRight
                  className="text-muted-foreground group-hover:text-[var(--jewel)] transition-colors"
                  size={18}
                />
              </div>
              <p className="mt-3 font-serif text-xl">Chat on WhatsApp</p>
            </a>
          </div>

          {/* Email — spans 7 cols */}
          <a
            href={`mailto:${PROFILE.email}`}
            data-testid="contact-email"
            className="md:col-span-7 group rounded-2xl border border-white/10 bg-white/[0.025] p-7 hover:border-[var(--jewel)] transition-colors"
          >
            <div className="flex items-center justify-between">
              <span className="text-eyebrow flex items-center gap-2">
                <Mail size={12} /> Email
              </span>
              <ArrowUpRight
                className="text-muted-foreground group-hover:text-[var(--jewel)] group-hover:-translate-y-1 group-hover:translate-x-1 transition-all"
                size={20}
              />
            </div>
            <p className="mt-4 font-serif text-2xl sm:text-3xl truncate">
              {PROFILE.email}
            </p>
          </a>

          {/* Location — full width bottom strip */}
          <div className="md:col-span-5 rounded-2xl border border-white/10 bg-white/[0.025] p-6 flex items-center gap-3 text-muted-foreground">
            <MapPin size={16} className="shrink-0 text-[var(--jewel)]" />
            <span className="font-serif text-lg">Based in {PROFILE.location}</span>
          </div>
        </div>
      </div>
    </section>
  );
}